// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetsListContent_container__11M98","title":"WidgetsListContent_title__3K6CD","widgetListing":"WidgetsListContent_widgetListing__3xlLL"};